(() => {
  if (window.__diamondDirectPurchaseReady) return;
  window.__diamondDirectPurchaseReady = true;

  document.addEventListener('click', (event) => {
    const choice = event.target.closest('quantity-breaks[data-direct-purchase="true"] .quantity-break');
    if (!choice || choice.classList.contains('quantity-break--disabled')) return;

    window.setTimeout(() => {
      const component = choice.closest('quantity-breaks[data-direct-purchase="true"]');
      const form =
        component.main_product_form ||
        document.querySelector('product-form form[action*="/cart/add"], form[action*="/cart/add"]');

      if (!form) {
        console.error('Diamond direct purchase: product form not found');
        return;
      }

      const submit = form.querySelector('[name="add"], button[type="submit"], input[type="submit"]');
      if (!submit || submit.disabled || submit.getAttribute('aria-disabled') === 'true') return;

      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(submit);
      } else {
        submit.click();
      }
    }, 20);
  });
})();
